"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.espoolKetteJsons = exports.espoolJson = exports.ketteJsonsMock = exports.espoolCenterMock = exports.espoolRightMock = exports.espoolLeftMock = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const EspoolLinearExtension_1 = require("./EspoolLinearExtension");
exports.espoolLeftMock = {
    Id: 800000000001,
    DataSource: 'stub',
    ArticleType: echain_product_models_1.ArticleType.espool,
    ArtNr: { DE: 'SP1.400.4000.01.L.0' },
    Bezeichnung: {
        'de-DE': 'e-spool® SP1.400',
        'en-GB': 'e-spool® SP1.400',
        'en-US': 'e-spool® SP1-400',
    },
    LinearKette: {
        Ref: '08.50.048.0',
        FixedNumGlieder: 215,
        IaRefs: ['B09.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 5,
        },
    },
    RightKette: {
        Ref: 'TB20.44.18.7.0',
        IaRefs: ['TB20.18.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 4,
        },
    },
    LeitungLengthMin: {
        Value: 6600,
        Unit: 'mm',
    },
    BiegeradiusMin: {
        Value: 34,
        Unit: 'mm',
    },
    LeitungDiameterMax: {
        Value: 12,
        Unit: 'mm',
    },
    TrommelDiameter: {
        Value: 400,
        Unit: 'mm',
    },
    LinearExtension: {
        Length: {
            Value: 4000,
            Unit: 'mm',
        },
        Position: EspoolLinearExtension_1.EspoolLinearExtensionPosition.left,
    },
    TotalWeight: {
        Value: 13.5,
        Unit: 'kg',
    },
    SerieKuerzel: {
        Metric: 'SP1',
        Imperial: 'SP1',
    },
};
exports.espoolRightMock = {
    Id: 800000000001,
    DataSource: 'stub',
    ArticleType: echain_product_models_1.ArticleType.espool,
    ArtNr: { DE: 'SP1.400.4000.01.R.0' },
    Bezeichnung: {
        'de-DE': 'e-spool® SP1.400',
        'en-GB': 'e-spool® SP1.400',
        'en-US': 'e-spool® SP1-400',
    },
    LinearKette: {
        Ref: '08.50.048.0',
        FixedNumGlieder: 215,
        IaRefs: ['B09.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 5,
        },
    },
    LeftKette: {
        Ref: 'TB20.44.18.7.0',
        IaRefs: ['TB20.18.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 4,
        },
    },
    LeitungLengthMin: {
        Value: 6600,
        Unit: 'mm',
    },
    BiegeradiusMin: {
        Value: 34,
        Unit: 'mm',
    },
    LeitungDiameterMax: {
        Value: 12,
        Unit: 'mm',
    },
    TrommelDiameter: {
        Value: 400,
        Unit: 'mm',
    },
    LinearExtension: {
        Length: {
            Value: 4000,
            Unit: 'mm',
        },
        Position: EspoolLinearExtension_1.EspoolLinearExtensionPosition.right,
    },
    TotalWeight: {
        Value: 13.5,
        Unit: 'kg',
    },
    SerieKuerzel: {
        Metric: 'SP1',
        Imperial: 'SP1',
    },
};
exports.espoolCenterMock = {
    Id: 800000000001,
    DataSource: 'stub',
    ArticleType: echain_product_models_1.ArticleType.espool,
    ArtNr: { DE: 'SP2.400.4000.01.0' },
    Bezeichnung: {
        'de-DE': 'e-spool® SP1.400',
        'en-GB': 'e-spool® SP1.400',
        'en-US': 'e-spool® SP1-400',
    },
    LeftKette: {
        Ref: 'TB20.44.18.7.0',
        IaRefs: ['TB20.18.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 4,
        },
    },
    LinearKette: {
        Ref: '08.50.048.0',
        FixedNumGlieder: 215,
        IaRefs: ['B09.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 5,
        },
        FixedPerNth: 60,
        StrainReliefSeparatorRefs: ['21.1.Z.1'],
    },
    RightKette: {
        Ref: 'TB20.44.18.7.0',
        IaRefs: ['TB20.18.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 4,
        },
    },
    LeitungLengthMin: {
        Value: 6600,
        Unit: 'mm',
    },
    BiegeradiusMin: {
        Value: 34,
        Unit: 'mm',
    },
    LeitungDiameterMax: {
        Value: 12,
        Unit: 'mm',
    },
    TrommelDiameter: {
        Value: 400,
        Unit: 'mm',
    },
    LinearExtension: {
        Length: {
            Value: 4000,
            Unit: 'mm',
        },
        Position: EspoolLinearExtension_1.EspoolLinearExtensionPosition.center,
    },
    TotalWeight: {
        Value: 13.5,
        Unit: 'kg',
    },
    SerieKuerzel: {
        Metric: 'SP2',
        Imperial: 'SP2',
    },
};
exports.ketteJsonsMock = [
    {
        Id: 1,
        ArtNr: { DE: '08.50.048.0' },
        Aussenbreite: { Value: 123, Unit: 'mm' },
        Aussenhoehe: { Value: 88, Unit: 'mm' },
        Innenbreite: { Value: 80, Unit: 'mm' },
        Innenhoehe: { Value: 21, Unit: 'mm' },
        Teilung: { Value: 20, Unit: 'mm' },
        K: { Value: 195, Unit: 'mm' },
    },
    {
        Id: 2,
        ArtNr: { DE: 'TB20.44.18.7.0' },
        Innenbreite: { Value: 44, Unit: 'mm' },
        Innenhoehe: { Value: 12, Unit: 'mm' },
    },
];
exports.espoolJson = {
    Id: 800000000001,
    DataSource: 'stub',
    ArticleType: echain_product_models_1.ArticleType.espool,
    ArtNr: { DE: 'SP1.400.4000.01.0' },
    Bezeichnung: {
        'de-DE': 'e-spool® SP1.400',
        'en-GB': 'e-spool® SP1.400',
        'en-US': 'e-spool® SP1-400',
    },
    LeftKette: {
        Ref: 'TB20.44.18.7.0',
        IaRefs: ['TB20.18.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 4,
        },
    },
    LinearKette: {
        Ref: '08.50.048.0',
        FixedNumGlieder: 215,
        IaRefs: ['B09.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 5,
        },
    },
    RightKette: {
        Ref: 'TB20.44.18.7.0',
        IaRefs: ['TB20.18.2.1'],
        FixedIaBeat: {
            startingAt: 1,
            perNth: 4,
        },
    },
    LeitungLengthMin: {
        Value: 6600,
        Unit: 'mm',
    },
    BiegeradiusMin: {
        Value: 34,
        Unit: 'mm',
    },
    LeitungDiameterMax: {
        Value: 12,
        Unit: 'mm',
    },
    TrommelDiameter: {
        Value: 400,
        Unit: 'mm',
    },
    LinearExtension: {
        Length: {
            Value: 4000,
            Unit: 'mm',
        },
        Position: EspoolLinearExtension_1.EspoolLinearExtensionPosition.center,
    },
    TotalWeight: {
        Value: 13.5,
        Unit: 'kg',
    },
    SerieKuerzel: {
        Metric: 'SP1',
        Imperial: 'SP1',
    },
};
exports.espoolKetteJsons = [
    {
        Id: 1,
        ArtNr: { DE: '08.50.048.0' },
        Teilung: { Value: 20, Unit: 'mm' },
        K: { Value: 195, Unit: 'mm' },
    },
    {
        Id: 2,
        ArtNr: { DE: 'TB20.44.18.7.0' },
    },
];
//# sourceMappingURL=espool.mock.js.map